import styled from "@emotion/styled";
import * as React from "react";

import { DesignToken, Icon, IconSource } from "@livechat/design-system-react-components";

import { EmptyState as EmptyStateComponent } from "components/empty-state/EmptyState";
import { withVar } from "themes/helpers";

const Container = styled.div`
  background-color: ${withVar(DesignToken.SurfacePrimaryDefault)};
  padding-top: 35px;
  display: flex;
  justify-content: center;
  color: var(${DesignToken.ContentBasicPrimary});
`;

interface IEmptyStateProps {
  icon: IconSource;
  title: string;
  description: string | React.ReactElement;
}

export const EmptyState: React.FC<IEmptyStateProps> = ({ icon, title, description }) => (
  <Container>
    <EmptyStateComponent title={title} icon={<Icon source={icon} size="xxxlarge" />}>
      {description}
    </EmptyStateComponent>
  </Container>
);
